export enum FailedDoorStatus {
  Failed = 1,
  Resolving = 2,
  Open = 3,
  Close = 4,
  Closed = 5,
  Resolved = 6,
}
